import Vue from 'vue';
import VueRouter from 'vue-router';
// import CallBack from '../views/callback';
import Mgr from '../assets/js/SecurityService';
Vue.use(VueRouter);
let mgr = new Mgr();
const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      requiresAuth: false,
      role: ['']
    },
    component: () => import('../views/login')
  },
  {
    path: '/callback',
    name: 'callback',
    meta: {
      requiresAuth: false,
      role: ['']
    },
    component: () => import('../views/callback')
  },
  // {
  //   path: '/error',
  //   name: 'error',
  //   meta: {
  //     requiresAuth: false,
  //     role: ['']
  //   },
  //   component: () => import('../views/error')
  // },
  {
    path: '/home',
    name: 'Home',
    redirect: '/home/chart',
    meta: {
      requiresAuth: true,
      role: ['SuperAdmin', 'Admin']
    },
    component: () => import('../views/Home'),
    children: [
      {
        path: 'chart',
        name: 'chart',
        meta: {
          requiresAuth: true,
          role: ['SuperAdmin', 'Admin']
        },
        component: () => import('../views/chart/chart')
      },
      {
        path: 'orderplat',
        name: 'orderplat',
        meta: {
          requiresAuth: true,
          role: ['SuperAdmin', 'Admin']
        },
        component: () => import('../views/order/plat')
      },
      {
        path: 'orderagent',
        name: 'orderagent',
        meta: {
          requiresAuth: true,
          role: ['SuperAdmin', 'Admin']
        },
        component: () => import('../views/order/agent')
      },
      {
        path: 'orderreissue',
        name: 'orderreissue',
        meta: {
          requiresAuth: true,
          role: ['SuperAdmin', 'Admin']
        },
        component: () => import('../views/order/reissue')
      },
      {
        path: 'exportTxt',
        name: 'exportTxt',
        meta: {
          requiresAuth: true,
          role: ['SuperAdmin', 'Admin']
        },
        component: () => import('../views/playerInfo/exportTxt')
      },
      {
        path: 'backOrder',
        name: 'backOrder',
        meta: {
          requiresAuth: true,
          role: ['SuperAdmin', 'Admin']
        },
        component: () => import('../views/order/backOrder')
      },
      {
        path: 'merchantplat',
        name: 'merchantplat',
        meta: {
          requiresAuth: true,
          role: ['SuperAdmin', 'Admin']
        },
        component: () => import('../views/merchant/plat')
      },
      {
        path: 'editmerchant',
        name: 'editmerchant',
        meta: {
          requiresAuth: true,
          role: ['SuperAdmin', 'Admin']
        },
        component: () => import('../views/merchant/editmerchant')
      },
      {
        path: 'merchantagent',
        name: 'merchantagent',
        meta: {
          requiresAuth: true,
          role: ['SuperAdmin', 'Admin']
        },
        component: () => import('../views/merchant/agent')
      },
      {
        path: 'merchantregister',
        name: 'merchantregister',
        meta: {
          requiresAuth: true,
          role: ['SuperAdmin', 'Admin']
        },
        component: () => import('../views/merchant/register')
      },
      {
        path: 'profitsharingsumpay',
        name: 'profitsharingsumpay',
        meta: {
          requiresAuth: true,
          role: ['SuperAdmin', 'Admin']
        },
        component: () => import('../views/profitsharing/sumpay')
      },
      {
        path: 'gamegroup',
        name: 'gamegroup',
        meta: {
          requiresAuth: true,
          role: ['SuperAdmin', 'Admin']
        },
        component: () => import('../views/game/group')
      },
      {
        path: 'gamearea',
        name: 'gamearea',
        meta: {
          requiresAuth: true,
          role: ['SuperAdmin', 'Admin']
        },
        component: () => import('../views/game/area')
      },
      {
        path: 'apayproudce',
        name: 'apayproudce',
        meta: {
          requiresAuth: true,
          role: ['SuperAdmin', 'Admin']
        },
        component: () => import('../views/apay/proudce')
      },
      {
        path: 'moneylist',
        name: 'moneylist',
        meta: {
          requiresAuth: true,
          role: ['SuperAdmin', 'Admin']
        },
        component: () => import('../views/moneymange/moneylist')
      },
      {
        path: 'apaythoroughfare',
        name: 'apaythoroughfare',
        meta: {
          requiresAuth: true,
          role: ['SuperAdmin', 'Admin']
        },
        component: () => import('../views/apay/thoroughfare')
      },
      {
        path: 'statisticstenantDayTrade',
        name: 'statisticstenantDayTrade',
        meta: {
          requiresAuth: true,
          role: ['SuperAdmin', 'Admin']
        },
        component: () => import('../views/statistics/tenantDayTrade')
      },
      {
        path: 'statisticsagentDayTrade',
        name: 'statisticsagentDayTrade',
        meta: {
          requiresAuth: true,
          role: ['SuperAdmin', 'Admin']
        },
        component: () => import('../views/statistics/agentDayTrade')
      },
      {
        path: 'statisticspartitionTrade',
        name: 'statisticspartitionTrade',
        meta: {
          requiresAuth: true,
          role: ['SuperAdmin', 'Admin']
        },
        component: () => import('../views/statistics/partitionTrade')
      },
      {
        path: 'statisticspublish',
        name: 'statisticspublish',
        meta: {
          requiresAuth: true,
          role: ['SuperAdmin', 'Admin']
        },
        component: () => import('../views/statistics/publish')
      },
      {
        path: 'newsMessagelist',
        name: 'newsMessagelist',
        meta: {
          requiresAuth: true,
          role: ['SuperAdmin', 'Admin']
        },
        component: () => import('../views/news/Messagelist')
      },
      {
        path: 'SystemsetupUserSettings',
        name: 'SystemsetupUserSettings',
        meta: {
          requiresAuth: true,
          role: ['SuperAdmin', 'Admin']
        },
        component: () => import('../views/Systemsetup/UserSettings')
      },
      {
        path: 'SystemsetupRolesetting',
        name: 'SystemsetupRolesetting',
        meta: {
          requiresAuth: true,
          role: ['SuperAdmin', 'Admin']
        },
        component: () => import('../views/Systemsetup/Rolesetting')
      },
      {
        path: 'Systemsetuprepay',
        name: 'Systemsetuprepay',
        meta: {
          requiresAuth: true,
          role: ['SuperAdmin', 'Admin']
        },
        component: () => import('../views/Systemsetup/repay')
      },
      {
        path: 'Logdailyrecord',
        name: 'Logdailyrecord',
        meta: {
          requiresAuth: true,
          role: ['SuperAdmin', 'Admin']
        },
        component: () => import('../views/Log/dailyrecord')
      },
      {
        path: 'moneymangeTOne',
        name: 'moneymangeTOne',
        meta: {
          requiresAuth: true,
          role: ['SuperAdmin', 'Admin']
        },
        component: () => import('../views/moneymange/TOne')
      },
      {
        path: 'moneymangeTZero',
        name: 'moneymangeTZero',
        meta: {
          requiresAuth: true,
          role: ['SuperAdmin', 'Admin']
        },
        component: () => import('../views/moneymange/TZero')
      },
      {
        path: 'moneymangereview',
        name: 'moneymangereview',
        meta: {
          requiresAuth: true,
          role: ['SuperAdmin', 'Admin']
        },
        component: () => import('../views/moneymange/review')
      },
      {
        path: 'moneymangepayment',
        name: 'moneymangepayment',
        meta: {
          requiresAuth: true,
          role: ['SuperAdmin', 'Admin']
        },
        component: () => import('../views/moneymange/payment')
      },
      {
        path: 'moneymangeexamine',
        name: 'moneymangeexamine',
        meta: {
          requiresAuth: true,
          role: ['SuperAdmin', 'Admin']
        },
        component: () => import('../views/moneymange/examine')
      },
      {
        path: 'moneymangebalance',
        name: 'moneymangebalance',
        meta: {
          requiresAuth: true,
          role: ['SuperAdmin', 'Admin']
        },
        component: () => import('../views/moneymange/balance')
      },
      {
        path: 'Systemsetuprealm',
        name: 'Systemsetuprealm',
        meta: {
          requiresAuth: true,
          role: ['SuperAdmin', 'Admin']
        },
        component: () => import('../views/Systemsetup/realm')
      },
      {
        path: 'Systemsetuprate',
        name: 'Systemsetuprate',
        meta: {
          requiresAuth: true,
          role: ['SuperAdmin', 'Admin']
        },
        component: () => import('../views/Systemsetup/rate')
      },
      {
        path: 'uploadres',
        name: 'uploadres',
        meta: {
          requiresAuth: true,
          role: ['SuperAdmin', 'Admin']
        },
        component: () => import('../views/Systemsetup/upload')
      },
      {
        path: 'systemset',
        name: 'systemset',
        meta: {
          requiresAuth: true,
          role: ['SuperAdmin', 'Admin']
        },
        component: () => import('../views/Systemsetup/systemset')
      },
      {
        path: 'behalfVersion',
        name: 'behalfVersion',
        meta: {
          requiresAuth: true,
          role: ['SuperAdmin', 'Admin']
        },
        component: () => import('../views/behalf/version')
      },
      {
        path: 'behalfBalance',
        name: 'behalfBalance',
        meta: {
          requiresAuth: true,
          role: ['SuperAdmin', 'Admin']
        },
        component: () => import('../views/behalf/balance')
      },
      {
        path: 'selfAccount',
        name: 'selfAccount',
        meta: {
          requiresAuth: true,
          role: ['SuperAdmin', 'Admin']
        },
        component: () => import('../views/behalf/selfAccount')
      },
      {
        path: 'selfAccountAdd',
        name: 'selfAccountAdd',
        meta: {
          requiresAuth: true,
          role: ['SuperAdmin', 'Admin']
        },
        component: () => import('../views/behalf/selfAccountAdd')
      },
      {
        path: 'selfAccountEdit',
        name: 'selfAccountEdit',
        meta: {
          requiresAuth: true,
          role: ['SuperAdmin', 'Admin']
        },
        component: () => import('../views/behalf/selfAccountEdit')
      },
      {
        path: 'daifuRecharge',
        name: 'daifuRecharge',
        meta: {
          requiresAuth: true,
          role: ['SuperAdmin', 'Admin']
        },
        component: () => import('../views/behalf/daifuRecharge')
      },
      {
        path: 'finishRecharge',
        name: 'finishRecharge',
        meta: {
          requiresAuth: true,
          role: ['SuperAdmin', 'Admin']
        },
        component: () => import('../views/behalf/finishRecharge')
      },
      {
        path: 'blackList',
        name: 'blackList',
        meta: {
          requiresAuth: true,
          role: ['SuperAdmin', 'Admin']
        },
        component: () => import('../views/behalf/blackList')
      },
      {
        path: 'blackListAdd',
        name: 'blackListAdd',
        meta: {
          requiresAuth: true,
          role: ['SuperAdmin', 'Admin']
        },
        component: () => import('../views/behalf/blackListAdd')
      },
      {
        path: 'staRecharge',
        name: 'staRecharge',
        meta: {
          requiresAuth: true,
          role: ['SuperAdmin', 'Admin']
        },
        component: () => import('../views/behalf/staRecharge')
      },
      {
        path: 'aliRecharge',
        name: 'aliRecharge',
        meta: {
          requiresAuth: true,
          role: ['SuperAdmin', 'Admin']
        },
        component: () => import('../views/behalf/aliRecharge')
      },
      {
        path: 'echarts',
        name: 'echarts',
        meta: {
          requiresAuth: true,
          role: ['SuperAdmin', 'Admin']
        },
        component: () => import('../views/behalf/echarts')
      },
      {
        path: 'syswechatconfig',
        name: 'syswechatconfig',
        meta: {
          requiresAuth: true,
          role: ['SuperAdmin', 'Admin']
        },
        component: () => import('../views/Systemsetup/syswechatconfig')
      },
      {
        path: 'gmwechatconfig',
        name: 'gmwechatconfig',
        meta: {
          requiresAuth: true,
          role: ['SuperAdmin', 'Admin']
        },
        component: () => import('../views/Systemsetup/gmwechatconfig')
      }
    ]
  },
  {
    path: '/accessdenied',
    name: 'AccessDenied',
    meta: {
      requiresAuth: false,
      role: []
    },
    component: () => import('../views/AccessDenied')
  }
];

const router = new VueRouter({
  routes
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  if (requiresAuth) {
    mgr.getRole().then(
      sucess => {
        var flag = false;
        console.log(to.meta);
        to.meta.role.forEach(r => {
          if (sucess === r) {
            flag = true;
          }
        });
        if (flag) {
          next();
        } else {
          next('/accessdenied');
        }
      },
      err => {
        console.log(err);
      }
    );
  } else {
    next();
  }
});
export default router;
